import { Flex, Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useAbility } from '~/core/contexts/AbilityContext';
import { useCleanUrl } from '~/shared/hooks';

type FooterProps = {
  className?: string;
  hidden?: boolean;
};

export function Footer({ className, hidden }: FooterProps) {
  const { t } = useTranslate('web-app');
  const { cleanUrl } = useCleanUrl();
  const ability = useAbility();

  if (ability.cannot('view', 'Footer') || hidden) {
    return null;
  }

  return (
    <Flex justify="center" align="end" className={className}>
      <Typography variant="body-sm-medium" className="text-center text-black">
        {`${t('footer.message')} `}
        <a
          href={cleanUrl(t('footer.service_now_link'))}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#0053ad] underline">
          {t('footer.service_now_label')}
        </a>
        .
      </Typography>
    </Flex>
  );
}
